import React from 'react';

import { Row, Col, Button, Form, FormGroup, Input } from 'reactstrap';
import { FieldFormGroup } from '../product/StaffCertificationApplicationProductCertDetails';

const StaffCertificationApplicationProductBuildingTypes = props => {
    const { checkboxOptions, selectedCheckboxOptions } = props.state;
    const { onBuildingTypesChange, onBuildingTypesSave } = props;
    return (
        <Row className="page-widget">
            <Col className="p-4">
                <Form>
                    <h4>Green Credentials Options</h4>
                    <FieldFormGroup name="greenCredentialsOptions" label="Please select below">
                        {checkboxOptions.map(option => (
                            <CheckboxComponent
                                key={option.id}
                                id={option.id}
                                checked={selectedCheckboxOptions[option.id] || false}
                                onChange={e => onBuildingTypesChange(e, option.id)}
                                label={option.buildingTypeOption}
                            />
                        ))}
                    </FieldFormGroup>
                </Form>
                <Col className="text-right mt-4">
                    <Button type="submit" className="primary-btn-style" onClick={onBuildingTypesSave}>
                        Save Changes
                    </Button>
                </Col>
            </Col>
        </Row>
    );
};

const CheckboxComponent = ({ id, checked, onChange, label }) => (
    <FormGroup check>
        <Input id={id} type="checkbox" checked={checked} onChange={onChange} />
        {label}
    </FormGroup>
);

export default StaffCertificationApplicationProductBuildingTypes;
